import React from "react";
import ReactLoading from "react-loading";
import "./Loader.css";
const Loader = ({ type, color, sincss, alto }) => {
  return (
    <div className={sincss ? "" : "loader-container"}>
      <ReactLoading
        type="cylon"
        color="#000000"
        height={alto ? alto : 267}
        width={75}
      />
    </div>
  );
};

export default Loader;
